import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

function Result(props) {

  const listItems = props.quizResult.map((gift) =>
    <li>{gift}</li>
  );

  return (
    <ReactCSSTransitionGroup
      className="container result"
      component="div"
      transitionName="fade"
      transitionEnterTimeout={800}
      transitionLeaveTimeout={500}
      transitionAppear
      transitionAppearTimeout={500}
    >
      <div className="results">
        <p>Thank you for taking the EquipConnectServe Gifts Assessment.
        The results below are listed in order from highest to lowest. 
        For a more detailed definition of each gift, please click{'\u00A0'}
          <a target="_blank" href="https://youruniquedesign.github.io/gift_descriptions.html">here </a>
        </p>

        <ol>{listItems}</ol>

        <p>For more information about spiritual gifts, their role in the Body of Christ, 
        and how they can impact your life and ministry, click{'\u00A0'}
          <a target="_blank" href="https://youruniquedesign.github.io/understanding_gifts.html">here </a>
        </p>

        <p>To connect with specific ministry opportunities in the church or the community, 
        check out the SERVE page of our website:{'\u00A0'}
          <a target="_blank" href="http://gracecommons.org/serve/">http://gracecommons.org/serve/ </a>
        and click on Opportunities to Serve in First Pres or Opportunities to Serve in the Community.</p>

        <p>Questions: contact me at{'\u00A0'}
          <a href="mailto:shirley.davis@gracecommons.org">shirley.davis@gracecommons.org</a>
        </p>

        <p>May God continue to help you grow in your understanding and use of your 
        gifts as you pursue Him.</p>

        <p>Blessings,<br />Shirley</p>

        <p>Shirley Giles Davis<br />
        Director, EquipConnectServe Ministries<br />
        Grace Commons Church, Boulder</p>
      </div>
    </ReactCSSTransitionGroup>
  );

}

Result.propTypes = {
  quizResult: React.PropTypes.array.isRequired,
};

export default Result;



// WEBPACK FOOTER //
// ./src/components/Result.js